import React from 'react';
import {
  Box,
  Container,
  Typography,
  Link
} from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#fff',
        color: '#111',
        py: 2,
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
          textAlign: { xs: 'center', sm: 'left' }
        }}>
          
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            © 2026 Vinogenes. Todos los derechos reservados.
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
            <Link 
              href="/privacidad" 
              color="#111" 
              underline="hover"
              variant="body2"
              sx={{ opacity: 0.9, '&:hover': { opacity: 1, color: '#E8D5C4' } }}
            >
              Privacidad
            </Link>
            <Link 
              href="/terminos" 
              color="#111" 
              underline="hover"
              variant="body2"
              sx={{ opacity: 0.9, '&:hover': { opacity: 1, color: '#E8D5C4' } }}
            >
              Términos
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 